import React from 'react';
import styled from 'styled-components';
import formatMoney from '../utils/formatMoney';

const DisplayStyles = styled.div`
  overflow-x: auto;
  th,
  td {
    border-bottom: 1px solid #ddd;
    font-size: clamp(1rem, 1.2vw, 1.4rem);
    line-height: normal;
  }
  tr:hover {
    background-color: #f5f5f5;
  }

  tr:nth-:first-child(even) {
    background-color: #f2f2f2;
  }
  th {
    background-color: #163869;
    color: white;
  }
  .resultsDisplay {
  }
`;

function SingleRecord({ record }) {
  return (
    <tr className={record.isinexcess ? 'mark singleRecord' : 'singleRecord'}>
      <td>
        <strong>{record.title}</strong>
      </td>
      <td>{record.author}</td>
      <td>{record.isbn}</td>
      <td>{record.copyright}</td>
      <td>{formatMoney(record.price)}</td>
      <td>{record.category}</td>
      <td>{record.date}</td>
      <td>{record.publisher}</td>
      <td>{record.notes}</td>
      <td>{record.isinexcess ? 'In Excess' : ''}</td>
    </tr>
  );
}

export default function RecordList({ records }) {
  return (
    <DisplayStyles>
      <table className="resultsDisplay">
        <tbody>
          <tr className="headerRow">
            <th>
              <strong>Title</strong>
            </th>
            <th>Author</th>
            <th>ISBN</th>
            <th>Copyright</th>
            <th>Price</th>
            <th>Category</th>
            <th>Date</th>
            <th>Publisher</th>
            <th>Notes</th>
            <th>In&nbsp;Excess</th>
          </tr>
          {records?.map((record) => (
            <SingleRecord record={record} key={record._id} />
          ))}
        </tbody>
      </table>
    </DisplayStyles>
  );
}
